var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgOrdersIconDark(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 17.341,
    height: 20,
    viewBox: "0 0 17.341 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "OrdersIcon",
    d: "M9,11V6a3,3,0,0,1,6,0v5M6.331,8H17.67a2,2,0,0,1,1.977,2.3l-1.255,8.152A3,3,0,0,1,15.426,21H8.574a3,3,0,0,1-2.965-2.544L4.354,10.3A2,2,0,0,1,6.331,8Z",
    transform: "translate(-3.33 -2)",
    fill: "none",
    stroke: "#212121",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOrdersIconDark);
export default __webpack_public_path__ + "static/media/OrdersIconDark.3f310f238e2277caceaffbc233eac2a9.svg";
export { ForwardRef as ReactComponent };